export default __webpack_public_path__ + "static/media/close.00b91764.svg";